import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FormModal from "./offerModal";
import { RootState } from "../redux/store/store";
import { useSelector } from "react-redux";
import {
  deleteTeacherOfferService,
  updateTeacherOfferService,
} from "../services/teacher-offer";
import { useLocation } from "react-router-dom";
import OfferStudentModal from "./offer-student-modal";
import {
  deleteStudentOfferService,
  updateStudentOfferService,
  sendOfferService,
  validatePromoCode as validatePromoCodeService,
} from "../services/student-offer";
import { getSpecialPromoCode } from "../services/promo-code-service";
import { SnackbarContext } from "../config/hooks/use-toast";
import "./cards.css";

// @ts-ignore
const OfferCard = ({ offer, onclick, onUpdateOffer, onDeleteOffer }) => {
  const location = useLocation();
  const isOfferStudent = location.pathname.includes("offer-student");
  const isTeacherOffer = !isOfferStudent;
  const snackbarContext = useContext(SnackbarContext);

  const userData = useSelector((state: RootState) => state?.user?.userData);
  const role = userData?.role?.name;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
  const teacherPriceFallback = Number(offer.monthlyPrice) || 0;
  const teacherPriceRaw = Number(offer.price);
  // Use explicit price when provided (>=0); otherwise fallback to legacy monthlyPrice
  const teacherPrice = teacherPriceRaw >= 0
    ? teacherPriceRaw
    : Math.max(0, teacherPriceFallback);
  const teacherPeriodMonths = Math.max(1, Number(offer.monthlyPeriod) || 1);

  const isFreeOffer = isOfferStudent
    ? ([offer.monthlyPrice, offer.trimesterPrice, offer.semesterPrice, offer.yearlyPrice].every(p => Number(p) === 0))
    : teacherPrice === 0;

  const themeColors = {
    free: {
      border: "#0FBE7F",
      title: "#0A5E40",
      subTitle: "#119868",
      price: "#0A8C63",
      priceBg: "#E8FBF3",
      badgeBg: "#E8FBF3",
      badgeText: "#0A5E40",
      check: "#0FBE7F",
      icon: "#0FBE7F",
      buttonStart: "#0FBE7F",
      buttonEnd: "#0A8C63",
      buttonHoverStart: "#0A8C63",
      buttonHoverEnd: "#0FBE7F",
    },
    paid: {
      border: "#0FBE7F",
      title: "#0A5E40",
      subTitle: "#119868",
      price: "#0A8C63",
      priceBg: "#E8FBF3",
      badgeBg: "#E8FBF3",
      badgeText: "#0A5E40",
      check: "#0FBE7F",
      icon: "#0FBE7F",
      buttonStart: "#0FBE7F",
      buttonEnd: "#0A8C63",
      buttonHoverStart: "#0A8C63",
      buttonHoverEnd: "#0FBE7F",
    }
  };

  const colors = isFreeOffer ? themeColors.free : themeColors.paid;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const benefitsArray = offer?.offerDetails?.split(/\s*\n\s*/)?.filter(Boolean) || [];

  const handleAction = (formData: any) => {
    if (isOfferStudent) {
      updateStudentOfferService(offer.id, formData)
        .then((updatedOffer) => {
          onUpdateOffer(updatedOffer.data);
          handleClose();
          handleCloseEditModal();
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succes",
              "Offre Modifier avec succée",
              "success",
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      updateTeacherOfferService(offer.id, formData)
        .then((updatedOffer) => {
          onUpdateOffer(updatedOffer.data);
          handleClose();
          handleCloseEditModal();
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succes",
              "Offre Ajouter avec succée",
              "success",
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleOpenEditModal = () => setIsEditModalOpen(true);
  const handleCloseEditModal = () => setIsEditModalOpen(false);
  const [open, setOpen] = React.useState(false);

  const handleClickAlert = () => {
    handleClose();
    console.log(offer);
    setOpen(true);
  };

  const handleCloseAlert = () => {
    setOpen(false);
  };
  const handleDelete = () => {
    if (isOfferStudent) {
      deleteStudentOfferService(offer.id)
        .then((res) => {
          setOpen(false);
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Succes",
              "Offre supprimer avec succée",
              "success",
            );
          }
          handleClose();
          onDeleteOffer();
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      deleteTeacherOfferService(offer.id)
        .then((res) => {
          setOpen(false);
          handleClose();
          onDeleteOffer();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  // Find the first available period with a price > 0 (students only)
  const availablePeriods = isOfferStudent
    ? [
        { key: 'MONTHLY', label: 'الشهري', price: offer.monthlyPrice },
        { key: 'TRIMESTER', label: 'الثلاثي', price: offer.trimesterPrice },
        { key: 'SEMESTER', label: 'السداسي', price: offer.semesterPrice },
        { key: 'YEARLY', label: 'السنوي', price: offer.yearlyPrice }
      ].filter(({ price }) => Number(price) > 0)
    : [];

  const defaultPeriod = availablePeriods.length > 0 ? availablePeriods[0].key : 'MONTHLY';
  const [selectedPeriod, setSelectedPeriod] = useState<'MONTHLY' | 'TRIMESTER' | 'SEMESTER' | 'YEARLY'>(defaultPeriod as any);
  const [subjectCount, setSubjectCount] = useState(1);
  const [paymentFile, setPaymentFile] = useState<File | null>(null);
  const [promoCode, setPromoCode] = useState("");
  const [promoError, setPromoError] = useState("");
  const [discountedTotal, setDiscountedTotal] = useState<number|null>(null);
  const [discountPercent, setDiscountPercent] = useState<number | null>(null);
  const [promoLoading, setPromoLoading] = useState(false);
  const [specialPromoCode, setSpecialPromoCode] = useState<string | null>(null);
  const [isSpecialPromoActive, setIsSpecialPromoActive] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const getPriceForPeriod = () => {
    if (!isOfferStudent) return teacherPrice;
    switch (selectedPeriod) {
      case 'MONTHLY':
        return offer.monthlyPrice;
      case 'TRIMESTER':
        return offer.trimesterPrice;
      case 'SEMESTER':
        return offer.semesterPrice;
      case 'YEARLY':
        return offer.yearlyPrice;
      default:
        return offer.monthlyPrice;
    }
  };

  // Helper to check if price is valid (not null/undefined and not NaN)
  const isValidPrice = (price: any) => price !== undefined && price !== null && !isNaN(price) && price !== '';

  const getSubjectMultiplier = () => {
    if (!isOfferStudent) return 1;
    // Special multipliers for YEARLY period
    if (selectedPeriod === 'YEARLY') {
      switch (subjectCount) {
        case 1: return 1;
        case 2: return 1.5;
        case 3: return 2.25;
        case 4: return 3;
        default: return subjectCount;
      }
    }
    // For other periods, 4 subjects = 3.5x
    if (subjectCount === 4) return 3.5;
    return subjectCount;
  };

  const getBaseTotalPrice = () => {
    const periodPrice = Number(getPriceForPeriod()) || 0;
    return Math.floor(periodPrice * Number(getSubjectMultiplier()));
  };

  const getReferencePrice = () => {
    if (!isOfferStudent) {
      return Math.floor(teacherPrice * teacherPeriodMonths);
    }
    const monthCount =
      selectedPeriod === "MONTHLY"
        ? 1
        : selectedPeriod === "TRIMESTER"
          ? 3
          : selectedPeriod === "SEMESTER"
            ? 6
            : 12;
    const monthlyPrice = Number(offer.monthlyPrice) || 0;
    return Math.floor(monthlyPrice * monthCount * Number(getSubjectMultiplier()));
  };

  const getCurrentPrice = () => discountedTotal ?? getBaseTotalPrice();

  const getTotalPrice = () => {
    if (discountedTotal !== null) return discountedTotal;
    return getBaseTotalPrice();
  };

  useEffect(() => {
    if (role === "ROLE_STUDENT" && userData?.id) {
      getSpecialPromoCode(userData.id)
        .then((data) => {
          const code = (data as any)?.code;
          const discount = (data as any)?.discountPercentage || 50;
          if (code) {
            setSpecialPromoCode(code);
            if (!promoCode || promoCode === code) {
              setIsSpecialPromoActive(true);
              setPromoCode(code);
              const baseTotal = getBaseTotalPrice();
              setDiscountPercent(discount);
              setDiscountedTotal(Math.max(0, Math.round(baseTotal - (baseTotal * (discount / 100)))));
            }
          }
        })
        .catch(() => {
          // Ignore missing special code
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, userData?.id]);

  useEffect(() => {
    if (isSpecialPromoActive && selectedPeriod === 'YEARLY') {
      setSelectedPeriod('MONTHLY');
    }
  }, [isSpecialPromoActive, selectedPeriod]);

  // Recalculate discounts when the base price changes (period/subjects)
  useEffect(() => {
    if (isOfferStudent && discountPercent !== null) {
      const baseTotal = getBaseTotalPrice();
      const discount = baseTotal * (discountPercent / 100);
      setDiscountedTotal(Math.max(0, Math.round(baseTotal - discount)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    discountPercent,
    selectedPeriod,
    subjectCount,
    offer.monthlyPrice,
    offer.trimesterPrice,
    offer.semesterPrice,
    offer.yearlyPrice,
  ]);

  return (
    <>
    <div 
      className="offer-card-shell modern-offer" 
      style={{ 
        borderColor: colors.border,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
        maxWidth: '340px',
        minHeight: '480px',
        padding: '4px 4px 10px',
        background: 'linear-gradient(145deg, #ffffff 0%, #f8fefb 40%, #ffffff 100%)',
        border: '2px solid #c8f1df',
        borderRadius: '24px',
        boxShadow: '0 8px 30px rgba(15, 190, 127, 0.12), 0 2px 10px rgba(0, 0, 0, 0.04)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        overflow: 'hidden',
      }}
    >
      <div className="offer-card-glow" style={{
        position: 'absolute',
        inset: 0,
        borderRadius: '22px',
        background: 'radial-gradient(circle at 30% 20%, rgba(15, 190, 127, 0.06), transparent 60%), radial-gradient(circle at 70% 80%, rgba(10, 140, 99, 0.04), transparent 55%)',
        pointerEvents: 'none',
        zIndex: 0,
      }} />

      {offer.subscribed && (
        <div className="offer-card-badge" style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          zIndex: 3,
          padding: '6px 12px',
          borderRadius: '999px',
          background: 'linear-gradient(135deg, #0FBE7F, #0A8C63)',
          color: '#fff',
          fontWeight: 700,
          fontSize: '11px',
          boxShadow: '0 6px 16px rgba(15, 190, 127, 0.3)',
          letterSpacing: '0.3px',
        }}>
          مشترك
        </div>
      )}

      <div className="offer-card-admin" style={{
        position: 'absolute',
        top: '8px',
        right: '8px',
        zIndex: 3,
      }}>
        {role === "ROLE_ADMIN" && (
          <IconButton onClick={handleClick} size="small" style={{ 
            color: colors.icon,
            background: 'rgba(255, 255, 255, 0.9)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}>
            <MoreVertIcon />
          </IconButton>
        )}
      </div>

      {isFreeOffer && (
        <span 
          className="offer-chip chip-free"
          style={{
            position: 'absolute',
            top: '8px',
            right: role === "ROLE_ADMIN" ? '48px' : '8px',
            zIndex: 3,
            padding: '6px 14px',
            borderRadius: '999px',
            fontWeight: 700,
            fontSize: '11px',
            letterSpacing: '0.4px',
            border: '1.5px solid transparent',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
            background: 'linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)',
            color: '#1e40af',
            borderColor: '#93c5fd',
          }}
        >
          مجاني
        </span>
      )}
      
      <div className="offer-card-hero" style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        marginTop: '2px',
        zIndex: 1,
      }}>
        <div className="offer-card-image" style={{ 
          borderColor: colors.border,
          width: '100%',
          height: '130px',
          borderRadius: '18px',
          border: '2px solid #0FBE7F',
          background: 'linear-gradient(135deg, #e8fbf3 0%, #f0fdf7 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          boxShadow: '0 8px 20px rgba(15, 190, 127, 0.15)',
          transition: 'all 0.3s ease',
        }}>
          <img
            src={offer?.imageUrl || "https://via.placeholder.com/300x208?text=Offre"}
            alt={offer.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
      </div>

      <div className="offer-card-heading" dir="rtl" style={{
        width: '100%',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        alignItems: 'center',
        padding: '0 4px',
      }}>
        <h2 className="offer-card-title" style={{ 
          color: colors.title,
          fontSize: '18px',
          fontWeight: 800,
          textAlign: 'center',
          lineHeight: 1.35,
          letterSpacing: '-0.2px',
          margin: 0,
        }}>
          {offer.title}
        </h2>
        {offer.subTitle && (
          <p style={{
            color: colors.subTitle,
            fontSize: '14px',
            fontWeight: 600,
            textAlign: 'center',
            lineHeight: 1.4,
            margin: '4px 0 0 0',
          }}>
            {offer.subTitle}
          </p>
        )}
        {offer.description && (
          <p style={{
            fontSize: '12px',
            lineHeight: '1.5',
            color: '#2d3748',
            textAlign: 'center',
            width: '100%',
            margin: '8px 0',
          }}>
            {offer.description}
          </p>
        )}
        <div className="offer-price-block" style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '4px',
          textAlign: 'center',
        }}>
          <span className="offer-card-price" style={{ 
            color: colors.price,
            fontSize: '28px',
            fontWeight: 900,
            letterSpacing: '-0.5px',
            direction: 'ltr',
          }}>
            {isValidPrice(getCurrentPrice()) && getCurrentPrice() > 0
              ? `${getCurrentPrice()} DT`
              : (isValidPrice(getCurrentPrice()) && getCurrentPrice() === 0)
                ? '0 DT'
                : '--'}
          </span>
          {isTeacherOffer && offer.monthlyPeriod && (
            <span className="offer-card-period" style={{
              fontSize: '10px',
              fontWeight: 600,
              color: '#0A8C63',
              letterSpacing: '0.3px',
            }}>لمدة {offer.monthlyPeriod} شهر</span>
          )}
          {(() => {
            const reference = getReferencePrice();
            const current = getCurrentPrice();
            return isOfferStudent && !isFreeOffer && isValidPrice(reference) && current < reference;
          })() && (
            <span className="offer-card-discount" style={{
              fontSize: '1.15rem', // ~18px
              fontWeight: 700,
              color: '#e11d48',
              background: 'rgba(255, 235, 238, 0.85)',
              padding: '4px 10px',
              borderRadius: '10px',
              marginTop: '4px',
              display: 'inline-block',
              letterSpacing: '0.2px',
              boxShadow: '0 2px 6px rgba(225, 29, 72, 0.08)',
            }}>
              بدلاً من <span className="line-through" style={{fontSize: '1.25rem', fontWeight: 800}}>{getReferencePrice()}DT</span>
            </span>
          )}
        </div>
      </div>

      {isOfferStudent && availablePeriods.length > 0 && (
        <div className="offer-section" style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          zIndex: 1,
        }}>
          <div className="offer-section-label" style={{
            fontWeight: 700,
            color: '#0A5E40',
            fontSize: '12px',
            textAlign: 'right',
            paddingInline: '4px',
          }}>المدة</div>
          <div className="offer-card-tabs" dir="rtl" style={{
            width: '100%',
            display: 'flex',
            border: '2px solid #c8f1df',
            borderRadius: '10px',
            overflow: 'hidden',
          }}>
            {availablePeriods.map(({ key, label }, index) => {
              const periodDisabled = isSpecialPromoActive && key === 'YEARLY';
              return (
                <button
                  key={key}
                  className={`offer-card-tab ${selectedPeriod === key ? 'active' : ''}`}
                  onClick={() => !periodDisabled && setSelectedPeriod(key as any)}
                  disabled={periodDisabled}
                  style={{
                    border: 'none',
                    borderLeft: index > 0 ? '1px solid #c8f1df' : 'none',
                    borderRadius: '0',
                    padding: '8px 6px',
                    margin: '0',
                    outline: 'none',
                    background: selectedPeriod === key 
                      ? 'linear-gradient(135deg, #0FBE7F, #0A8C63)' 
                      : '#fff',
                    color: selectedPeriod === key ? '#fff' : '#0FBE7F',
                    fontWeight: 700,
                    fontSize: '11px',
                    textAlign: 'center',
                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                    boxShadow: 'none',
                    cursor: periodDisabled ? 'not-allowed' : 'pointer',
                    transform: 'none',
                    flex: '1 1 auto',
                    minWidth: '60px',
                    opacity: periodDisabled ? 0.6 : 1,
                  }}
                >
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {isOfferStudent && !isFreeOffer && (
        <div className="offer-section" dir="rtl" style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          zIndex: 1,
        }}>
          <div className="offer-section-label" style={{
            fontWeight: 700,
            color: '#0A5E40',
            fontSize: '12px',
            textAlign: 'right',
            paddingInline: '4px',
          }}>عدد المواد</div>
          <div className="offer-subject-buttons" style={{
            display: 'flex',
            border: '2px solid #c8f1df',
            borderRadius: '10px',
            overflow: 'hidden',
          }}>
            {offer.allSubjects ? (
              <button 
                className="offer-subject-button active"
                style={{
                  border: 'none',
                  borderRadius: '0',
                  padding: '8px 6px',
                  margin: '0',
                  outline: 'none',
                  background: 'linear-gradient(135deg, #0FBE7F, #0A8C63)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: '11px',
                  boxShadow: 'none',
                  cursor: 'pointer',
                  transform: 'none',
                  flex: '1 1 auto',
                  minWidth: '60px',
                }}
              >
                كل المواد
              </button>
            ) : (
              Array.from({ length: offer.subjectCount || 4 }, (_, i) => i + 1).map((count, index) => (
                <button
                  key={count}
                  className={`offer-subject-button ${subjectCount === count ? 'active' : ''}`}
                  onClick={() => setSubjectCount(count)}
                  style={{
                    border: 'none',
                    borderLeft: index > 0 ? '1px solid #c8f1df' : 'none',
                    borderRadius: '0',
                    padding: '8px 6px',
                    margin: '0',
                    outline: 'none',
                    background: subjectCount === count 
                      ? 'linear-gradient(135deg, #0FBE7F, #0A8C63)' 
                      : '#fff',
                    color: subjectCount === count ? '#fff' : '#0FBE7F',
                    fontWeight: 700,
                    fontSize: '11px',
                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                    boxShadow: 'none',
                    cursor: 'pointer',
                    transform: 'none',
                    flex: '1 1 auto',
                    minWidth: '60px',
                  }}
                >
                  <span dir="rtl" style={{ unicodeBidi: 'plaintext' }}>
                    <b>{count}</b> {count === 1 ? 'مادة' : 'مواد'}
                  </span>
                </button>
              ))
            )}
          </div>
        </div>
      )}

      <div className="offer-benefits-wrapper" dir="rtl" style={{
        width: '100%',
        flex: 1,
        maxHeight: '160px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        paddingTop: '2px',
        paddingRight: '4px',
        zIndex: 1,
        overflowY: 'auto',
        scrollbarWidth: 'thin',
        scrollbarColor: '#0FBE7F #e8fbf3',
      }}>
        {benefitsArray.length === 0 ? (
          <p className="text-sm text-center text-gray-500">لا توجد تفاصيل مضافة لهذا العرض</p>
        ) : (
          benefitsArray.map((benefit: any, index: React.Key) => (
            <p key={index} className="offer-benefit-text" style={{
              fontSize: '12px',
              lineHeight: '1.5',
              color: '#2d3748',
              textAlign: 'right',
              width: '100%',
              margin: '4px 0',
            }}>
              <CheckCircleIcon fontSize="small" style={{ color: '#0FBE7F', marginLeft: '8px' }} />
              {benefit}
            </p>
          ))
        )}
      </div>

      {(!offer.subscribed && role !== "ROLE_ADMIN") && (
        <button
            className="offer-cta-button"
            onClick={() => {
              if (isOfferStudent) {
                if (isFreeOffer) {
                  onclick();
                } else {
                  handleOpenModal();
                }
              } else {
                onclick();
              }
            }}
            style={{
              width: '100%',
              padding: '14px 20px',
              background: 'linear-gradient(135deg, #0FBE7F 0%, #0A8C63 100%)',
              color: '#fff',
              fontSize: '15px',
              fontWeight: 700,
              borderRadius: '14px',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: '0 8px 20px rgba(15, 190, 127, 0.35)',
              position: 'relative',
              overflow: 'hidden',
              zIndex: 1,
            }}
          >
          {isFreeOffer ? 'انضم مجاناً' : 'اشترك الآن'}
          </button>
          )}
      </div>

      {/* Student Offer Request Modal */}
      {isOfferStudent && (
        <Dialog open={isModalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
          <DialogTitle className="flex items-center justify-between text-white bg-primary">
            <span className="text-xl font-montserrat_semi_bold">طلب الاشتراك</span>
            <IconButton onClick={handleCloseModal} className="text-white">
              <span style={{ fontSize: 24, fontWeight: 'bold', lineHeight: 1 }}>&times;</span>
            </IconButton>
          </DialogTitle>
          <DialogContent className="px-6 py-6">

            {/* Period Selection */}
            <div className="mb-6">
              <Typography variant="h6" className="mb-3 text-right font-montserrat_medium">اختر الفترة</Typography>
              <div className="flex justify-center gap-2 mb-4">
                {[...availablePeriods].reverse().map(({ key, label }) => {
                  const periodDisabled = isSpecialPromoActive && key === 'YEARLY';
                  return (
                    <button
                      key={key}
                      className={`flex-1 px-3 py-2 text-sm font-bold rounded-lg border transition-all duration-300 ${
                        selectedPeriod === key
                          ? 'bg-primary text-white border-primary shadow'
                          : 'bg-white text-primary border-primary hover:bg-blue-50'
                      }`}
                      onClick={() => !periodDisabled && setSelectedPeriod(key as any)}
                      disabled={periodDisabled}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Subject Count Selection */}
            {/* Subject Count Selection: only for paid offers */}
            {!isFreeOffer && (
              <div className="mb-6">
                <Typography variant="h6" className="mb-3 text-right font-montserrat_medium">عدد المواد</Typography>
                <div className="flex justify-center gap-2 mb-4">
                  {offer.allSubjects ? (
                    <button
                      className="flex-1 px-3 py-2 text-sm font-bold text-white border rounded-lg shadow bg-primary border-primary"
                    >
                      <span dir="rtl" style={{ unicodeBidi: 'plaintext', fontFamily: 'inherit' }}>كل المواد</span>
                    </button>
                  ) : (
                    [...Array.from({ length: offer.subjectCount || 4 }, (_, i) => i + 1)].reverse().map(count => (
                      <button
                        key={count}
                        className={`flex-1 px-3 py-2 text-sm font-bold rounded-lg border transition-all duration-300 ${
                          subjectCount === count
                            ? 'bg-primary text-white border-primary shadow'
                            : 'bg-white text-primary border-primary hover:bg-blue-50'
                        }`}
                        onClick={() => setSubjectCount(count)}
                      >
                        <span dir="rtl" style={{ unicodeBidi: 'plaintext', fontFamily: 'inherit' }}><b>{count}</b>&nbsp;{count === 1 ? 'مادة' : 'مواد'}</span>
                      </button>
                    ))
                  )}
                </div>
              </div>
            )}

            {/* Price Summary */}
            <div className="p-4 mb-6 rounded-lg bg-gradient-to-r from-green-50 to-blue-50">
              <div className="flex items-center justify-between mb-2">
                <span className="font-medium text-gray-700">{offer.allSubjects ? 'السعر:' : 'سعر المادة الواحدة:'}</span>
                <span className="font-bold text-primary">{getPriceForPeriod()} د.ت</span>
              </div>
              <div className="flex items-center justify-between mb-2">
                <span className="font-medium text-gray-700">عدد المواد:</span>
                <span className="font-bold text-primary">{offer.allSubjects ? 'كل المواد' : subjectCount}</span>
              </div>
              <hr className="my-2" />
              <div className="flex items-center justify-between">
                <span className="text-lg font-bold text-gray-800">المجموع:</span>
                <div className="flex flex-col items-end">
                  <div className="flex items-baseline gap-2">
                    {(() => {
                      const reference = getReferencePrice();
                      const current = getTotalPrice();
                      return !isFreeOffer && isValidPrice(reference) && current < reference;
                    })() && (
                      <span className="text-base font-medium line-through" style={{ color: '#EF4444' }}>{getReferencePrice()} د.ت</span>
                    )}
                    <span className="text-xl font-bold text-green-600">{getTotalPrice()} د.ت</span>
                  </div>
                  {(() => {
                    const reference = getReferencePrice();
                    const current = getTotalPrice();
                    return !isFreeOffer && isValidPrice(reference) && current < reference;
                  })() && (
                    <span className="text-xs font-medium text-green-600">وفّر {getReferencePrice() - getTotalPrice()} د.ت</span>
                  )}
                </div>
              </div>
            </div>
            {/* Promo Code Input */}
            <div className="mb-6">
              <label htmlFor="promo-code-input" className="block mb-2 text-base font-bold text-primary">Code Promo (optionnel)</label>
              <input
                id="promo-code-input"
                type="text"
                value={promoCode}
                onChange={async e => {
                  const code = e.target.value;
                  setPromoCode(code);
                  setPromoError("");
                  setDiscountedTotal(null);
                  setDiscountPercent(null);
                  setIsSpecialPromoActive(code === specialPromoCode);
                  if (!code) {
                    setIsSpecialPromoActive(false);
                    return;
                  }
                  setPromoLoading(true);
                  try {
                    const res = await validatePromoCodeService(code, offer.id, userData?.id || "", selectedPeriod);
                    const validation = res?.data ?? res;
                    const discountValue = Number(validation?.discountPercentage);
                    if (validation?.isValid && !isNaN(discountValue)) {
                      const baseTotal = getBaseTotalPrice();
                      const discount = baseTotal * (discountValue / 100);
                      setDiscountPercent(discountValue);
                      setDiscountedTotal(Math.max(0, Math.round(baseTotal - discount)));
                      setPromoError("");
                      const isSpecial = Boolean(validation?.isSpecialReward);
                      setIsSpecialPromoActive(isSpecial);
                      if (isSpecial) {
                        setSpecialPromoCode(code);
                        if (selectedPeriod === 'YEARLY') {
                          setSelectedPeriod('MONTHLY');
                        }
                      }
                    } else {
                      setPromoError("كود التخفيض غير صالح أو منتهي الصلاحية");
                      setDiscountedTotal(null);
                      setDiscountPercent(null);
                      setIsSpecialPromoActive(false);
                    }
                  } catch (err) {
                    setPromoError("حدث خطأ أثناء التحقق من الكود");
                    setDiscountedTotal(null);
                    setDiscountPercent(null);
                    setIsSpecialPromoActive(false);
                  } finally {
                    setPromoLoading(false);
                  }
                }}
                placeholder="ادخل كود التخفيض هنا"
                className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2 text-lg font-semibold bg-yellow-50 ${promoError ? 'border-red-500 focus:ring-red-500' : 'border-primary focus:ring-primary'}`}
                style={{ letterSpacing: '0.1em' }}
                disabled={promoLoading}
              />
              {promoLoading && <div className="mt-1 text-xs text-gray-500">جاري التحقق من الكود...</div>}
              {promoError && <div className="mt-1 text-xs font-bold text-red-600">{promoError}</div>}
              <div className="mt-4">
                <input
                  id="payment-proof"
                  type="file"
                  onChange={e => setPaymentFile(e.target.files?.[0] || null)}
                  accept="image/*,.pdf"
                  className="hidden"
                />
                <label
                  htmlFor="payment-proof"
                  className="flex items-center justify-between w-full px-4 py-3 transition border-2 border-dashed cursor-pointer rounded-xl hover:border-primary hover:bg-primary/5"
                >
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 text-primary">
                      <UploadFileIcon fontSize="medium" />
                    </div>
                    <div className="flex flex-col text-sm">
                      <span className="font-semibold text-gray-800">أرفق وصل الدفع</span>
                      <span className="text-gray-500">صورة أو PDF بحد أقصى 5MB</span>
                    </div>
                  </div>
                  <span className="px-3 py-1 text-sm font-bold text-white rounded-lg bg-primary">اختيار ملف</span>
                </label>
                {paymentFile && (
                  <div className="flex items-center justify-between p-3 mt-3 border border-green-200 rounded-lg bg-green-50">
                    <div className="flex items-center gap-2 text-sm font-medium text-green-700">
                      <span className="text-green-600">✓</span>
                      <span>{paymentFile?.name}</span>
                    </div>
                    <button
                      className="text-xs font-semibold text-red-500 hover:underline"
                      onClick={() => setPaymentFile(null)}
                      type="button"
                    >
                      إزالة
                    </button>
                  </div>
                )}
              </div>
            </div>
          </DialogContent>
          <DialogActions className="px-6 pb-6" style={{ justifyContent: 'center' }}>
            <button
              onClick={async () => {
                if (!paymentFile || subjectCount < 1) return;
                setSubmitLoading(true);
                try {
                  const formData = new FormData();
                  formData.append("selectedPeriod", selectedPeriod);
                  formData.append("requestedSubjectsCount", subjectCount.toString());
                  formData.append("finalPrice", getTotalPrice().toString());
                  if (promoCode) formData.append("promoCode", promoCode);
                  formData.append("paymentImage", paymentFile);

                  await sendOfferService(offer.id, formData);

                  if (snackbarContext) {
                    snackbarContext.showMessage(
                      "نجح",
                      "تم إرسال طلب الاشتراك بنجاح",
                      "success"
                    );
                  }
                  handleCloseModal();
                  setSelectedPeriod('MONTHLY');
                  setSubjectCount(1);
                  setPaymentFile(null);
                  setPromoCode("");
                  setDiscountedTotal(null);
                  setDiscountPercent(null);
                } catch (error) {
                  console.error(error);
                  if (snackbarContext) {
                    snackbarContext.showMessage(
                      "خطأ",
                      "فشل إرسال طلب الاشتراك",
                      "error"
                    );
                  }
                } finally {
                  setSubmitLoading(false);
                }
              }}
              disabled={!paymentFile || subjectCount < 1 || submitLoading}
              style={{
                width: '100%',
                maxWidth: '400px',
                padding: '16px 32px',
                background: (!paymentFile || subjectCount < 1 || submitLoading) 
                  ? 'linear-gradient(135deg, #94a3b8 0%, #64748b 100%)'
                  : 'linear-gradient(135deg, #0FBE7F 0%, #0A8C63 100%)',
                color: '#fff',
                fontSize: '16px',
                fontWeight: 700,
                borderRadius: '12px',
                border: 'none',
                cursor: (!paymentFile || subjectCount < 1 || submitLoading) ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: (!paymentFile || subjectCount < 1 || submitLoading)
                  ? '0 4px 12px rgba(100, 116, 139, 0.3)'
                  : '0 8px 24px rgba(15, 190, 127, 0.4)',
                position: 'relative',
                overflow: 'hidden',
                letterSpacing: '0.3px',
                transform: 'translateY(0)',
              }}
              onMouseEnter={(e) => {
                if (!(!paymentFile || subjectCount < 1 || submitLoading)) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 12px 32px rgba(15, 190, 127, 0.5)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #0A8C63 0%, #0FBE7F 100%)';
                }
              }}
              onMouseLeave={(e) => {
                if (!(!paymentFile || subjectCount < 1 || submitLoading)) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(15, 190, 127, 0.4)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #0FBE7F 0%, #0A8C63 100%)';
                }
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                {submitLoading ? (
                  <>
                    <span style={{ 
                      display: 'inline-block',
                      width: '18px',
                      height: '18px',
                      border: '3px solid rgba(255, 255, 255, 0.3)',
                      borderTopColor: '#fff',
                      borderRadius: '50%',
                      animation: 'spin 0.8s linear infinite'
                    }} />
                    <span>جاري الإرسال...</span>
                  </>
                ) : (
                  <>
                    <span style={{ fontSize: '18px', fontWeight: 900 }}>✓</span>
                    <span>تأكيد و إرسال ({getTotalPrice()} د.ت)</span>
                  </>
                )}
              </div>
            </button>
            <style>{`
              @keyframes spin {
                to { transform: rotate(360deg); }
              }
            `}</style>
          </DialogActions>
        </Dialog>
      )}
      {/* Admin/Teacher Modals */}
      {isOfferStudent ? (
        <OfferStudentModal
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          initialData={{ image: offer.imageUrl, ...offer }}
          modalTitle="Modifier l'offre"
          buttonText="Mettre à jour"
          onButtonClick={handleAction}
        />
      ) : (
        <FormModal
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          initialData={{ image: offer.imageUrl, ...offer }}
          modalTitle="Modifier l'offre"
          buttonText="Mettre à jour"
          onButtonClick={handleAction}
        />
      )}
      
      {/* Admin Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => { handleClose(); handleOpenEditModal(); }}>
          Modifier
        </MenuItem>
        <MenuItem onClick={handleClickAlert}>
          Supprimer
        </MenuItem>
      </Menu>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={open}
        keepMounted
        onClose={handleCloseAlert}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <p className="text-2xl font-bold text-gray-800">
            Confirmer la suppression
          </p>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <p className="text-gray-600">
              Êtes-vous sûr de vouloir supprimer cette offre? Cette action est irréversible.
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={handleCloseAlert}
            className="text-gray-700 border-gray-300 hover:bg-gray-50"
          >
            Annuler
          </Button>
          <Button
            variant="contained"
            onClick={handleDelete}
            className="text-white bg-red-600 hover:bg-red-700"
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OfferCard;




